import { render, staticRenderFns } from "./Box.vue?vue&type=template&id=594c3949&scoped=true&"
import script from "./Box.vue?vue&type=script&lang=js&"
export * from "./Box.vue?vue&type=script&lang=js&"
import style0 from "./Box.vue?vue&type=style&index=0&id=594c3949&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594c3949",
  null
  
)

component.options.__file = "Box.vue"
export default component.exports